import { useEffect } from 'react';
import {
  RegisterOptions,
  useFormContext,
} from 'react-hook-form/dist/index.ie11';

export function useRequiredForAutoInvoicing(
  errorMessage: string,
  name: string
): RegisterOptions {
  const {
    watch,
    trigger,
    formState: { dirtyFields, touched },
  } = useFormContext();

  const isAutoInvoicingTouched = touched.autoInvoicingEnabled;
  const isAutoInvoicingDirty = dirtyFields.autoInvoicingEnabled;

  const autoInvoicingEnabled = watch('autoInvoicingEnabled');

  useEffect(() => {
    const shouldTriggerValidationOnUserInteraction =
      isAutoInvoicingDirty || isAutoInvoicingTouched;

    if (shouldTriggerValidationOnUserInteraction) {
      trigger(name);
    }
  }, [
    autoInvoicingEnabled,
    name,
    trigger,
    isAutoInvoicingTouched,
    isAutoInvoicingDirty,
  ]);

  return autoInvoicingEnabled ? { required: errorMessage } : null;
}
